import React from "react";

const SessionSkeleton = () => (
  <div className="animate-pulse">
    {/* Mobile Create Session Button Skeleton */}
    <div className="md:hidden mb-4">
      <div className="w-full h-14 bg-gray-200 rounded-lg"></div>
    </div>

    {/* Session Groups - Create 2 skeleton groups */}
    {[1, 2].map((group) => (
      <div key={group} className="mb-8">
        {/* Date Header Skeleton */}
        <div className="text-xl font-semibold mb-4 flex items-center gap-2 sticky top-0 bg-gray-50/80 backdrop-blur-sm py-3 z-10">
          <div className="w-5 h-5 bg-gray-200 rounded"></div>
          <div className="w-32 h-6 bg-gray-200 rounded"></div>
        </div>

        {/* Session Cards - Create 2 skeleton cards per group */}
        <div className="space-y-4">
          {[1, 2].map((session) => (
            <div
              key={session}
              className="bg-white rounded-lg shadow-md border border-gray-200 w-full"
            >
              <div className="p-5 border-b border-gray-200">
                <div className="flex items-start gap-3 mb-3">
                  <div className="w-6 h-6 bg-gray-200 rounded mt-1"></div>
                  <div className="flex-1">
                    <div className="flex items-center justify-between">
                      <div className="w-3/4 h-6 bg-gray-200 rounded"></div>
                      <div className="w-20 h-6 bg-gray-200 rounded-full"></div>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="text-gray-600 text-sm flex items-center justify-between ml-8">
                    <div className="flex items-center gap-2">
                      <div className="w-4 h-4 bg-gray-200 rounded"></div>
                      <div className="w-32 h-4 bg-gray-200 rounded"></div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex items-center gap-2 justify-center p-4 w-full">
                <div className="w-full h-10 bg-gray-200 rounded"></div>
                <div className="w-full h-10 bg-gray-200 rounded"></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    ))}
  </div>
);

export default SessionSkeleton;
